import { useGetApiProfileQuery } from "@shared/api";
import { LOCAL_STORAGE } from "@shared/constants";
import { useEffect } from "react";

interface UseUserProfileOptions {
  skip?: boolean;
}

export const useUserProfile = (options?: UseUserProfileOptions) => {
  const {
    data: profile,
    isLoading,
    error,
  } = useGetApiProfileQuery(undefined, {
    skip: options?.skip,
  });

  useEffect(() => {
    if (profile?.data.name) {
      localStorage.setItem(LOCAL_STORAGE.Name, profile.data.name || "No name");
    }
  }, [profile?.data.name]);

  const isProfileCompleted = Boolean(
    profile?.data.name ||
      profile?.data.description ||
      profile?.data.birth_date ||
      (profile?.data.skills && profile.data.skills.length > 0) ||
      (profile?.data.interests && profile.data.interests.length > 0)
  );

  const areAllFieldsFilled = Boolean(
    profile?.data.name &&
      profile?.data.description &&
      profile?.data.birth_date &&
      profile?.data.skills &&
      profile?.data.skills.length > 0 &&
      profile?.data.interests &&
      profile?.data.interests.length > 0
  );

  const getUnfilledFieldsMessage = () => {
    if (!profile?.data) return "Профиль не загружен";

    const unfilledFields = [];

    if (!profile.data.name) unfilledFields.push("Имя");
    if (!profile.data.description) unfilledFields.push("О себе");
    if (!profile.data.birth_date) unfilledFields.push("Дата рождения");
    if (!profile.data.skills?.length) unfilledFields.push("Навыки");
    if (!profile.data.interests?.length) unfilledFields.push("Интересы");

    if (unfilledFields.length === 0) return "Все поля заполнены";

    return `Не заполнены поля: ${unfilledFields.join(", ")}`;
  };

  const isNewProfile =
    localStorage.getItem(LOCAL_STORAGE.IsNewProfile) === "true";

  return {
    isProfileCompleted,
    areAllFieldsFilled,
    isLoading,
    error,
    unfilledFieldsMessage: getUnfilledFieldsMessage(),
    isNewProfile,
  };
};
